import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { sectionUploadPdfExamFormValidation } from '../../validation/Validation';
import { ErrorMessage } from '../../validation/validationError';
import { ZodError } from 'zod';
import { Loader } from '../../components/ModalsCommonFunctions';
import Select from 'react-select';

const UploadPdfExam = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload();
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);

    const initialExamPatterState = {
        exam_name: "",
        description: "",
        class_id: '',
        subject_ids: [],
        pdf_url: '',
        total_questions: "",
        section_id: sectionMasterId
    }

    const [examCreateData, setExamCreateData] = useState(initialExamPatterState)
    const [subjectList, setSubjectList] = useState([])
    const [classList, setClassList] = useState([])
    const [error, setError] = useState([]);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })

        if (value.trim() !== '') {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    useEffect(() => {
        getClassList();
        getSubjectList();
    }, [])

    const getClassList = () => {
        const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setClassList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log("Error fetching data: ", errorMsg);
            });
    }

    const getSubjectList = () => {
        const apiUrl = `/get-institute-subjects?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log("Error fetching data: ", errorMsg);
            });
    }

    const SubList = subjectList?.map((sub) => ({
        value: sub.subjectMasterId.toString(), // Ensure value is always a string
        label: sub.subjectName,
    })) || [];

    const handleSubjectChange = (selectedOptions) => {
        const selectedIds = selectedOptions.map(option => option.value.toString());
        setExamCreateData((prevData) => {
            return {
                ...prevData,
                subject_ids: selectedIds,
            }
        })

        if (selectedIds.length !== 0) {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== "subject_ids"));
        }
    }


    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];
        let fileExtension = file?.name?.substring(file?.name?.lastIndexOf('.') + 1).toLowerCase();
        if (fileExtension === "pdf") {

            if (file.size <= 30 * 1024 * 1024) {
                setLoading(true);
                const body = new FormData();
                body.append('file', file)
                body.append("flag", "1");  //2 -> exam path in s3 bucket

                const apiUrl = "uploadfile-v2";
                authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                    .then((res) => {
                        setExamCreateData((prevData) => {
                            return {
                                ...prevData,
                                [e.target.name]: res.data.result
                            }
                        })

                        if (e.target.value.trim() !== '') {
                            setError(prevErrors => prevErrors.filter(error => error.path[0] !== e.target.name));
                        }
                    })
                    .catch((err) => {
                        const errorMsg = err.response.data.error || "Something went wrong!";
                        Swal.fire({
                            text: errorMsg
                        })
                    })
                    .finally(() => {
                        setLoading(false); // End loading
                    });
            }
        } else {
            Swal.fire(
                { text: "Only pdf file supported" }
            );
        }
    }

    const uploadExam = async () => {
        try {
            await sectionUploadPdfExamFormValidation.parseAsync(examCreateData);
            setError([]);

            setLoading(true);

            const apiUrlForSyllabus = `/upload-pdf-exam-v2`;
            const response = await authorizedAxiosSection.post(apiUrlForSyllabus, examCreateData);

            setExamCreateData(initialExamPatterState);

            if (inputRef.current) {
                inputRef.current.value = '';
            }
            Swal.fire({ text: response.data.message });
        } catch (err) {
            if (err instanceof ZodError) {
                setError(err.errors);
            } else {
                const errorMsg = err?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleInputReset = () => {
        setExamCreateData(initialExamPatterState);
        setError([]);
        inputRef.current.value = '';
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Upload Pdf Exam</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i>Upload Pdf Exam </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name </label>
                                                    <input type="text" className="form-control" id={`examName`} name='exam_name' onChange={(e) => handleInputChange(e)} value={examCreateData.exam_name} />
                                                    <ErrorMessage errors={error} field="exam_name" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="description" className="col-form-label"><span style={{ color: "red" }}>*</span>Description  </label>
                                                    <input type="text" className="form-control" id={`description`} name='description' onChange={(e) => handleInputChange(e)} value={examCreateData.description} />
                                                    <ErrorMessage errors={error} field="description" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="class_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleInputChange} value={examCreateData.class_id}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            classList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="class_id" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <Select
                                                        value={SubList.filter(option =>
                                                            examCreateData.subject_ids.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="subject_ids"
                                                        options={SubList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Subject"
                                                        onChange={handleSubjectChange}
                                                    />
                                                    <ErrorMessage errors={error} field="subject_ids" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Exam Question :<span style={{ color: "red" }}> Only pdf file supported </span></label>
                                                    <input type="file" className="form-control" id={`file`} name='pdf_url' onChange={(e) => handleUploadLogo(e)} value={examCreateData?.pdf_url?.name} ref={inputRef} />
                                                    {/* <a download href='https://api.examninja.co.in/files/question-bank-import-ex.xlsx'>Sample pdf file</a> */}

                                                    <ErrorMessage errors={error} field="pdf_url" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="total_questions" className="col-form-label"><span style={{ color: "red" }}>*</span>Total No Of Question: </label>
                                                    <input type="number" className="form-control" id={`total_questions`} name='total_questions' onChange={handleInputChange} value={examCreateData.total_questions} />
                                                    <ErrorMessage errors={error} field="total_questions" />
                                                </div>
                                            </div>

                                            <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <div className="col-auto">
                                                    <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={uploadExam}>Save</button>
                                                    <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default UploadPdfExam;